"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

import { useAppSelector } from "@/redux/store";
import { useLocalStorage } from "@/hooks/useStorage";
import Button from "@/components/common/PrimaryButton";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import UserDropdownMenu from "./UserDropdownMenu";
import Avatar from "@/components/common/Avatar";

const UserControls = () => {
  const pathname = usePathname() as string;
  const searchParams = useSearchParams();
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user.subscriptionType !== "free");
  const authLoading = useAppSelector((state) => state.user.authLoading);
  const [_, setRedirectPath] = useLocalStorage("redirectPath", "/");

  const handleLoginClick = () => {
    const redirectPath = `${pathname}${searchParams ? `?${searchParams}` : ""}`;
    setRedirectPath(redirectPath);
  };

  const placeholder = !authLoading ? (
    <Link href="/signin" onClick={handleLoginClick}>
      <Button color="secondary">Login</Button>
    </Link>
  ) : null;

  if (!user) return placeholder;

  return (
    <div className="tw:flex tw:gap-4">
      <div className="tw:flex tw:flex-col tw:justify-center tw:gap-1">
        <p className="tw:hidden tw:lg:block tw:lg:text-right tw:lg:text-sm tw:lg:font-medium">
          {user.username}
        </p>
        <div className="tw:flex tw:items-center tw:gap-5">
          {!isSubscribed && (
            <Link href="/subscribe">
              <Button
                color="secondary"
                className="tw:w-[80px] tw:h-5 tw:rounded-sm tw:text-xxs tw:lg:w-[107px] tw:lg:h-6 tw:lg:text-sm"
              >
                Upgrade
              </Button>
            </Link>
          )}
          <p className="tw:hidden tw:lg:block tw:lg:uppercase tw:lg:text-xs tw:lg:font-light tw:lg:italic">
            {user.subscriptionType === "creator-pro"
              ? "Creator Pro"
              : user.subscriptionType}
          </p>
        </div>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="tw:grid tw:place-items-center">
            <Avatar
              src={user.avatarUrl || ""}
              alt={user.username}
              className="tw:w-[30px] tw:h-[30px] tw:cursor-pointer tw:lg:w-[55px] tw:lg:h-[55px]"
            />
          </div>
        </DropdownMenuTrigger>
        <UserDropdownMenu user={user} />
      </DropdownMenu>
    </div>
  );
};

export default UserControls;
